import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PrimeTemplate } from 'primeng/api';
import { PageInfo } from '../../../core/models/page-info';

/**
 * 查詢表單元件
 *
 * @export
 * @class QueryFormContainerComponent
 * @implements {OnInit}
 * @implements {AfterContentInit}
 */
@Component({
  selector: 'sigv-query-form-container',
  templateUrl: './query-form-container.component.html',
  styleUrls: ['./query-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueryFormContainerComponent implements OnInit, AfterViewInit {
  @Input() autoCollapse = true;

  /**
   * 進階搜尋
   */
  @Input() advanced = false;

  /**
   * 收合
   */
  @Input() collapse = false;

  /**
   * Form Group
   */
  @Input() formGroup: FormGroup = new FormGroup({});

  /**
   * 顯示收合展開按鈕
   */
  @Input() showCollapseWidget = true;

  /**
   * 顯示清除按鈕
   */
  @Input() showClear = true;

  /**
   * 是否在dealerweb使用（是的話查詢按鈕會有icon）
   */
  @Input() isDealerWeb = false;

  /**
   * 顯示查詢按鈕
   */
  @Input() showSearch = true;

  /**
   * 清除按鈕文字
   */
  @Input() clearText?: string;

  /**
   * 查詢按鈕文字
   */
  @Input() searchText?: string;

  /**
   * pageInfo
   */
  @Input() pageInfo?: PageInfo;
  /**
   * 查詢事件
   */
  @Output() search: EventEmitter<void> = new EventEmitter<void>();

  /**
   * 清除事件
   */
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  /**
   * 收合展開事件
   */
  @Output() collapseChange = new EventEmitter<boolean>();
  /**
   * pageInfo 變更
   */
  @Output() pageInfoChange = new EventEmitter<PageInfo>();
  @ContentChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
  @ViewChild('searchForm') searchFormEle!: ElementRef;
  conditionsTemplate?: TemplateRef<any>;
  advancedTemplate?: TemplateRef<any>;
  buttonsTemplate?: TemplateRef<any>;
  suffixButtonsTemplate?: TemplateRef<any>;
  advancedConditionalFormActiveState = false;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}

  get displaySearchText(): string {
    return this.searchText ?? 'Search';
  }

  get displayClearText(): string {
    return this.clearText ?? 'Clear';
  }

  ngAfterViewInit(): void {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'conditions':
          this.conditionsTemplate = item.template;
          break;
        case 'advanced':
          this.advancedTemplate = item.template;
          break;
        case 'buttons':
          this.buttonsTemplate = item.template;
          break;
        case 'suffixButtons':
          this.suffixButtonsTemplate = item.template;
          break;
        default:
          break;
      }
    });
    this.cd.detectChanges();
  }

  /**
   * 隱藏/顯示進階搜尋
   *
   * @memberof QueryFormContainerComponent
   */
  toggleAdvancedConditionalFormActiveState(): void {
    this.advancedConditionalFormActiveState =
      !this.advancedConditionalFormActiveState;
  }

  /**
   * 收合/展開查詢條件表單
   *
   * @memberof QueryFormContainerComponent
   */
  toggleConditionalFormActiveState(): void {
    this.collapse = !this.collapse;
    this.collapseChange.emit(this.collapse);
  }

  /**
   * 查詢按鈕 Click 事件
   *
   * @param {*} event
   * @memberof QueryFormContainerComponent
   */
  searchBtnClick(event: any): void {
    if (this.autoCollapse && this.showCollapseWidget) {
      this.toggleConditionalFormActiveState();
    }
    const pageSize = this.pageInfo?.pageSize ?? 10;
    this.pageInfo = new PageInfo();
    this.pageInfo.pageSize = pageSize;
    this.pageInfoChange.emit(this.pageInfo);
    this.search.emit();
  }

  /**
   * 清除按鈕 Click 事件
   *
   * @param {*} event
   * @memberof QueryFormContainerComponent
   */
  cancelBtnClick(event: any): void {
    this.formGroup.reset();
    const pageSize = this.pageInfo?.pageSize ?? 10;
    this.pageInfo = new PageInfo();
    this.pageInfo.pageSize = pageSize;
    this.pageInfoChange.emit(this.pageInfo);
    this.cancel.emit();
  }
}
